module.exports = __webpack_public_path__ + "img/jihua.6bb708d2.png";